import { inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { SeahorseFormBuilder } from '@seahorse/forms';

export function createForgotPasswordForm() {
  const fb = inject(SeahorseFormBuilder);

  return fb.group({
    emailAddress: fb.control<string | null>(null, [
      Validators.required,
      Validators.email,
    ]),
  });
}
